module.exports = __webpack_public_path__ + "media/MENNICA.f5a6e264.mp3";